import { PrivateRoom } from '@/api/types/private-room';
import { RouteInfo } from './navigation';
import { parsePostsRoute } from './secret';

export const privateMemberLabels = {
  none: '未加入',
  pending: '待审批',
  joined: '已加入',
  rejected: '申请被拒绝',
  left: '已退出',
  expired: '已到期',
  banned: '已拉黑',
};
export const isPrivateRoom = (room): boolean => !!room && (room.isPrivate === true || room.game === '_private');
export const canReadPrivateRoom = (room: PrivateRoom): boolean => !!room && (room.joined || room.canComment);
export const privateRoomContentLocation = (room: PrivateRoom): RouteInfo => parsePostsRoute(room.filter);
export const privateRoomTime = (seconds?: number | null): string =>
  (seconds && seconds > 0 ? new Date(seconds * 1000).toLocaleString('zh-CN', { hour12: false }) : '—');
export const canPrepayPrivateRoom = (room: PrivateRoom, now = Date.now()): boolean =>
  !!(room.joined && room.orderId && !room.hasPrepaid && !room.nextOrderId && room.expiresAt
    && room.expiresAt * 1000 > now && room.expiresAt * 1000 - now <= 3 * 86400000);
export const privateRoomError = (error): string =>
  (error && error.response && error.response.errmsg) || (error && error.message) || '网络连接失败，请重试';
